export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
                无论你是漫画作者、翻译组成员，还是有合作意向的伙伴，欢迎随时联系我们。投稿、商务合作、版权咨询、问题反馈，皮皮漫画团队期待与你的交流。
              </p>
              <div className="flex flex-wrap items-center gap-4 mt-5 justify-center lg:justify-start">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span>contact@pipimh.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-wechat-line text-primary-500 text-lg"></i>
                  <span>皮皮漫画官方</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                提交合作咨询
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}